import React, { createContext, useContext, useState } from "react";
import { saveToken, readToken, readRole, clearToken, readAccountId, saveAccountId, clearAccountId } from "../utils/auth";

//TODO: secure storage of token
//TODO: refresh token handling

export interface AuthContextValue {
  token: string | null;
  accountId: string | null;
  role: string | null;
  login: (token: string, accountId: string) => void;
  logout: () => void;
  isAuthenticated: boolean;
  getToken: () => string | null;
  getAccountId: () => string | null;
}

interface AuthProviderProps {
  children: React.ReactNode;
}

const AuthContext = createContext<AuthContextValue | undefined>(undefined);

export function AuthProvider({ children }: AuthProviderProps) {
  const [token, setToken] = useState<string | null>(() => readToken());
  const [role, setRole] = useState<string | null>(() => readRole());
  const [accountId, setAccountId] = useState<string | null>(() => readAccountId());

  const login = (t: string, accountId: string) => {
    setToken(t);
    saveToken(t);
    setRole(readRole());
    setAccountId(accountId);
    saveAccountId(accountId);
  };

  const logout = () => {
    setToken(null);
    setRole(null);
    clearToken();
    setAccountId(null);
    clearAccountId();
  };

  const getToken = () => token ?? readToken();

  const getAccountId = () => accountId ?? readAccountId();

  return (
    <AuthContext.Provider value={{ token, role, accountId, login, logout, isAuthenticated: !!token, getToken, getAccountId }}>
      {children}
    </AuthContext.Provider>
  );
};

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}